module.exports = __webpack_public_path__ + "img/layout-sidebar-inset-reverse.86ba51f8.svg";